import script from "./AboutMeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutMeModal.vue?vue&type=script&setup=true&lang=js"

import "./AboutMeModal.vue?vue&type=style&index=0&id=fb2760c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krili\\Projects\\krilin_website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb2760c4"]])

export default __exports__